import React from 'react';
// import '../../assets/css/high_traffic.scss';
// import hourglass from '../../assets/img/hourglass.png';
// import logo from '../../assets/img/CMSH_V2/logo.png';

const scheduledMaintenance = () => {
  return (
    <div className="high_trafic">
      <div className="bg_white">
        <header className="topnav ">
          <div className="container">
            <nav className="navbar navbar-expand-lg text-center  justify-content-center">
              <a
                className="navbar-brand animate__animated animate__fadeInUp animate__delay-1s animated-element"
                href="index.html"
              >
                {/* <img src={logo} alt="Logo" height="50" /> */}
              </a>
            </nav>
          </div>
        </header>

        <section className="termswrapper">
          <div className="container">
            <div className="row d-flex align-items-center justify-content-center">
              <div className="col-lg-8 pe-lg-2 mt-lg-0 mt-md-5 mt-sm-4 mt-0 text-center col-12  terms_div">
                {/* <img
                  src={hourglass}
                  alt="claim"
                  height="100"
                  className="mb-4 hrglass"
                /> */}
                <h2 className="mb-4">We're Experiencing High Traffic</h2>
                <p>
                  Thank you for your patience. Due to high demand, we’ll send
                  you a secure link via SMS or email shortly. You can use it to
                  complete your claim at your convenience.
                </p>
                <p>
                  We appreciate your understanding and look forward to assisting
                  you!
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default scheduledMaintenance;
